module.exports = __webpack_public_path__ + "static/media/labs-logo.e24b171d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/labs-logo.png
// module id = 2889
// module chunks = 0